import React from "react";

export default function MainContent() {
  return (
    <div className="main-content">
      <h2 className="about-title">About</h2>
      <p className="me">
        I am a frontend developer with a particular interest in making things
        simple and automating daily tasks. I try to keep up with security and
        best practices, and am always looking for new things to learn.
      </p>
      <h2 className="interests-title">Interests</h2>
      <p className="interests">
        Food expert. Music scholar. Reader. Internet fanatic. Bacon buff.
        Entrepreneur. Travel geek. Pop culture ninja. Coffee fanatic.
      </p>
    </div>
  );
}
